import { useEffect } from 'react';
import { useUser } from '../UserContext';

export const useAuthenticatedEffect = (effect) => {
    const { user } = useUser();

    useEffect(() => {
        if (user) {
            effect();
        }
    }, [user, effect]);
};